// Get random int between min and max inclusively
export function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function getNumberWithinRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}